import { render, staticRenderFns } from "./UserTouristList.vue?vue&type=template&id=75488e3c&scoped=true"
import script from "./UserTouristList.vue?vue&type=script&lang=js"
export * from "./UserTouristList.vue?vue&type=script&lang=js"
import style0 from "./UserTouristList.vue?vue&type=style&index=0&id=75488e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75488e3c",
  null
  
)

export default component.exports